module.exports = __webpack_public_path__ + "img/trig.fce618e2.svg";